// import svg icons/images
import svgAzure from '../../assets/images/svg/azure.svg';
import svgAWSMarketplace from '../../assets/images/svg/aws.svg';
import svgGoogle from '../../assets/images/svg/gcp.svg';
import svgSSO from '../../assets/images/svg/sso.svg';
import svgForm from '../../assets/images/svg/icon-form.svg';
import svgMsg from '../../assets/images/svg/icon-msg.svg';
import svgGUID from '../../assets/images/svg/icon-guid.svg';
import imgWelcome from '../../assets/images/svg/welcome.svg';
import svgAvxLogo from '../../assets/images/svg/logo.svg';
import imgAvxHomeLogo from '../../assets/images/svg/axv-logo.svg';
import svgDivider from '../../assets/images/svg/nav-divider.svg';
import imgProfile from '../../assets/images/profile.jpg';
import imgSucccess from '../../assets/images/svg/copilot-luanch.svg';
import imgCopilotLuanch from '../../assets/images/svg/status-success.svg';
import svgTF from '../../assets/images/svg/TF.svg';
import svgWorking from '../../assets/images/svg/working.svg';
import svgCloudShell from '../../assets/images/svg/cloudShell.svg';

// svg Icons/Images
export const IconAzure = svgAzure;
export const IconGoogle = svgGoogle;
export const IconSSO = svgSSO;
export const IconForm = svgForm;
export const IconMsg = svgMsg;
export const IconGUID = svgGUID;
export const IconAWSMarketplace = svgAWSMarketplace;
export const IconDivider = svgDivider;
export const IconTF = svgTF;
export const ImgProfile = imgProfile;
export const ImgWelcome = imgWelcome;
export const ImgAvxLogo = svgAvxLogo;
export const ImgAvxHomeLogo = imgAvxHomeLogo;
export const ImgSucccess = imgSucccess;
export const ImgCopilotLuanch = imgCopilotLuanch;
export const ImgWorking = svgWorking;
export const IconCloudShell = svgCloudShell;

